import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "transaction_detail"
};
const _hoisted_2 = {
  class: "base_screen_header"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_4 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_5 = {
  class: "td_money_item"
};
const _hoisted_6 = {
  class: "tdm_title"
};
const _hoisted_7 = {
  class: "base_main_header"
};
const _hoisted_8 = {
  class: "base_main_margin_top"
};
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { OP_KEY, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import { $msg, $box } from "@ui/msg";
import { ref, reactive, watch } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import api from "@api/finance";
import configApi from "@api/config";
import $ from "@util/base";
export default {
  __name: 'TransactionDetail',

  setup(__props) {
    const route = useRoute();
    route.watchRouter("transactiondetail", () => {
      getData();
      getMoney();
    });
    const dealOptions = ref([{
      label: "收入",
      value: "1"
    }, {
      label: "退款",
      value: "2"
    }]);
    const orderOptions = ref([{
      label: "商品",
      value: "1017001"
    }, {
      label: "旅行",
      value: "1017002"
    }, {
      label: "酒店",
      value: "1017003"
    }, {
      label: "综合活动",
      value: "1017004"
    }, {
      label: "会员订单",
      value: "1017006"
    }]);
    const payOptions = ref([{
      label: "微信支付",
      value: "1021001"
    }, {
      label: "储值卡支付",
      value: "1021002"
    }]);
    const baseOptions = ref([]);
    getConfig();

    function getConfig() {
      api.base(val => {
        baseOptions.value = val;
      });
    }

    const deal = ref(route.query().deal || "");
    const order = ref(route.query().order || "");
    const pay = ref(route.query().pay || "");
    const base = ref(route.query().base || ""); // const number = ref(route.query().number || "");

    const date = ref(route.query().date || []);
    const data = ref([]);
    const total = ref(0);

    function querySearchName(queryString, cd) {
      configApi.sku(queryString, val => {
        cd(val);
      });
    }

    const name = ref('');
    const name1 = ref('');

    function transactionOperations(data) {
      return [OPERATIONS.check];
    }

    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: transactionOperations
      },
      column: [{
        label: "交易号",
        prop: "transactionNo"
      }, {
        label: "产品信息",
        prop: "productInfo",
        width: 150
      }, {
        label: "金额（元）",
        prop: "transactionMoney",
        width: 110
      }, {
        label: "关联订单",
        prop: "orderCode",
        width: 150
      }, {
        label: "支付单号",
        prop: "mainOrderCode",
        width: 150
      }, {
        label: "订单类型",
        prop: "mainBusiType",
        width: 90
      }, {
        label: "储值抵扣金额（元）",
        prop: "changeMoney",
        width: 100
      }, {
        label: "支付方式",
        prop: "payType",
        width: 100
      }, {
        label: "交易类型",
        prop: "transactionType",
        width: 100
      }, {
        label: "归属基地",
        prop: "shopName",
        width: 110
      }, {
        label: "成本",
        prop: "costPrice",
        width: 100
      }, {
        label: "毛利",
        prop: "profitMoney",
        width: 100
      }, {
        label: "毛利率",
        prop: "profitRate",
        width: 100
      }, {
        label: "交易时间",
        prop: "createTime",
        width: 150
      }, {
        label: "分销员",
        prop: "agentMemberName",
        width: 90
      }]
    };
    const opHander = operationsHander();
    opHander.install(OP_KEY.check, data => {
      route.push({
        name: "detailsview",
        query: {
          code: data.mainOrderCode
        }
      });
    });

    function searchDeal(val) {
      route.replaceQuery("deal", val);
    }

    function searchOrder(val) {
      route.replaceQuery("order", val);
    }

    function searchPay(val) {
      route.replaceQuery("pay", val);
    }

    function searchBase(val) {
      route.replaceQuery("base", val);
    }

    function searchName(val) {
      route.replaceQuery('name1', val);
    } // function searchNumber(val) {
    //   console.log(val);
    //   route.replaceQuery("number", val);
    // }


    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    function selectName(val) {
      route.replaceQuerys([{
        replaceKey: "sku",
        val: val.itemCode
      }, {
        replaceKey: "type",
        val: val.itemType
      }]);
    }

    getData();
    getMoney();

    function getData() {
      let routeQuery = route.query();
      api.list({
        transactionType: routeQuery.deal,
        mainBusiType: routeQuery.order,
        payType: routeQuery.pay,
        base: routeQuery.base,
        sku: routeQuery.sku,
        type: routeQuery.type,
        date: routeQuery.date,
        page: routeQuery.p,
        size: routeQuery.s,
        name1: routeQuery.name1
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          if (e.orderCode === undefined || e.orderCode === null || e.orderCode === "") {
            e.orderCode = "———";
          }

          if (e.transactionNo === undefined || e.transactionNo === null || e.transactionNo === "") {
            e.transactionNo = "———";
          }

          if (e.productInfo === undefined || e.productInfo === null || e.productInfo === "") {
            e.productInfo = "———";
          }

          if (e.shopName === undefined || e.shopName === null || e.shopName === "") {
            e.shopName = "———";
          }

          if (e.costPrice === undefined || e.costPrice === null || e.costPrice === "") {
            e.costPrice = "———";
          }

          if (e.profitMoney === undefined || e.profitMoney === null || e.profitMoney === "") {
            e.profitMoney = "———";
          }

          if (e.profitRate === undefined || e.profitRate === null || e.profitRate === "") {
            e.profitRate = "———";
          }

          if (e.agentMemberName === undefined || e.agentMemberName === null || e.agentMemberName === "") {
            e.agentMemberName = "———";
          }

          switch (e.mainBusiType) {
            case "1017001":
              e.mainBusiType = "商品";
              break;

            case "1017002":
              e.mainBusiType = "旅行";
              break;

            case "1017003":
              e.mainBusiType = "酒店";
              break;

            case "1017004":
              e.mainBusiType = "综合活动";
              break;

            case "1017006":
              e.mainBusiType = "会员订单";
              break;
          }

          switch (e.transactionType) {
            case 1:
              e.transactionType = "收入";
              break;

            case 2:
              e.transactionType = "退款";
              break;
          }

          switch (e.payType) {
            case "1021001":
              e.payType = "微信支付";
              break;

            case "1021002":
              e.payType = "储值支付";
              break;
          }

          return e;
        });
      });
    }

    const moneyList = reactive([{
      label: "总交易额(元)",
      total: 0
    }, {
      label: "退款金额(元)",
      total: 0
    }, {
      label: "实际交易额(元)",
      total: 0
    }]);

    function getMoney() {
      let routeQuery = route.query();
      api.num({
        transactionType: routeQuery.deal,
        mainBusiType: routeQuery.order,
        payType: routeQuery.pay,
        base: routeQuery.base,
        sku: routeQuery.sku,
        type: routeQuery.type,
        date: routeQuery.date,
        page: routeQuery.p,
        size: routeQuery.s,
        name1: routeQuery.name1
      }, val => {
        moneyData(val);
      });
    }

    function moneyData(val) {
      moneyList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function exportData() {
      let routeQuery = route.query();
      api.exportData({
        transactionType: routeQuery.deal,
        mainBusiType: routeQuery.order,
        payType: routeQuery.pay,
        // loginName: routeQuery.base,
        // loginName: routeQuery.number,
        date: routeQuery.date
      }, val => {
        $.download(val.url, "商品列表导出");
      });
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_autocomplete = _resolveComponent("el-autocomplete");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: date.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => date.value = $event),
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "value-format": "YYYY-MM-DD",
              onChange: searchDate
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: base.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => base.value = $event),
              onChange: searchBase,
              placeholder: "请选择基地",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: deal.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => deal.value = $event),
              onChange: searchDeal,
              placeholder: "请选择交易类型",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: pay.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => pay.value = $event),
              onChange: searchPay,
              placeholder: "请选择支付类型",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: order.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => order.value = $event),
              onChange: searchOrder,
              placeholder: "请选择订单类型",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderOptions.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_autocomplete, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => name.value = $event),
              "fetch-suggestions": querySearchName,
              placeholder: "请输入商品名称",
              onSelect: selectName,
              "select-when-unmatched": ""
            }, {
              default: _withCtx(({
                item
              }) => [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(item.productName), 1), _createElementVNode("span", _hoisted_4, " " + _toDisplayString(item.skuName), 1)])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: name1.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => name1.value = $event),
              onChange: searchName,
              placeholder: "产品名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moneyList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_col, {
              key: index,
              span: 8
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.label), 1), _createElementVNode("h2", null, _toDisplayString(item.total), 1)])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          text: "",
          onClick: exportData
        }, {
          default: _withCtx(() => [_createTextVNode("导出")]),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_createVNode(DataCollectTable, {
          data: data.value,
          total: total.value,
          config: config,
          onOperationsHander: _unref(opHander).receive
        }, null, 8, ["data", "total", "onOperationsHander"])])]),
        _: 1
      })]);
    };
  }

};